import styled from "styled-components";
import { DROPDOWN_OVER_MODAL_Z_INDEX } from "../../../../utils";
import { ThisGorillaUtils } from "@thisgorilla/primate-ds";

export const MediaDropDownContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  width: 100%;
  max-width: 906px;
`;

export const Container = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.spacing["spacing-9"].value}rem;
  left: -${ThisGorillaUtils.convertPxToRem("141")}rem;
  z-index: ${DROPDOWN_OVER_MODAL_Z_INDEX};
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary"].value};
`;

export const DropDownContainer = styled.div`
  padding: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-s"]};
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  border: 1px solid
    ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary"].value};
`;

export const RelativeContainer = styled.div<{ $isActive: boolean }>`
  position: relative;

  & > button {
    background-color: ${({ $isActive, theme }) =>
      $isActive &&
      theme.Color.background.brand.subtler["default-active"].value};
    border-color: ${({ $isActive, theme }) =>
      $isActive && theme.Color.border["ui-border-emphasize-brand"].value};
  }
`;
